import { Button, Modal, Typography, Radio, DatePicker, Space } from 'antd'
import { useState } from 'react'
import moment from 'moment'
import { toast } from 'react-toastify'
import { endRecurring2Booking } from '../../../../services/booking.service'

interface ConfirmCancalBookingProps {
  trigger: React.ReactNode
  bookingId: string
  onSave?: () => void
}

enum EndType {
  Immediate = 'Immediate',
  Scheduled = 'Scheduled'
}

export const EndRecurringBooking = ({ trigger, bookingId, onSave }: ConfirmCancalBookingProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [endType, setEndType] = useState<EndType>(EndType.Immediate)
  const [selectedDate, setSelectedDate] = useState<moment.Moment | null>(null)

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const handleConfirmEnd = async () => {
    if (bookingId) {
      const date = endType === EndType.Immediate ? undefined : selectedDate?.toISOString()
      try {
        await endRecurring2Booking(bookingId, date)
        toast.success('Success cancel booking')
        // this.redirectToSchedule()
        onSave?.()
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }
  }

  return (
    <>
      <div style={{ width: '100%' }} onClick={() => setIsModalOpen(true)}>
        {trigger}
      </div>
      <Modal
        width={618}
        closable={false}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        className={`modal-base`}
      >
        <Typography.Title level={4} className='modal-title'>
          End Recurring Booking
        </Typography.Title>
        <div>
          <div style={{ marginBottom: 24 }}>
            <Radio.Group onChange={(e) => setEndType(e.target.value)} value={endType}>
              <Space direction='vertical'>
                <Radio value={EndType.Immediate}>
                  <span style={{ fontWeight: 600 }}>End now</span>
                  <div style={{ color: '#666' }}>Ends immediately. No future bookings will be generated.</div>
                </Radio>
                <Radio value={EndType.Scheduled}>
                  <span style={{ fontWeight: 600 }}>End on a selected date</span>
                  <div style={{ marginTop: 8 }}>
                    <div style={{ marginBottom: 4, fontWeight: 500 }}>Selected Date*</div>
                    <DatePicker
                      size='large'
                      style={{ width: 300 }}
                      format='DD/MM/YYYY'
                      value={selectedDate}
                      onChange={(date) => setSelectedDate(date)}
                      placeholder='Select date'
                      disabled={endType !== EndType.Scheduled}
                      disabledDate={(current) => {
                        return current && current < moment().startOf('day')
                      }}
                    />
                    <div style={{ marginTop: 4, color: '#666' }}>Bookings after this date will not be generated.</div>
                  </div>
                </Radio>
              </Space>
            </Radio.Group>
          </div>
        </div>
        <div className='action-button'>
          <Button
            onClick={handleConfirmEnd}
            onDoubleClick={handleConfirmEnd}
            className='primary'
            style={{ width: '100%', height: 50, fontWeight: 600 }}
          >
            Confirm
          </Button>
          <Button className='secondary' style={{ width: '100%', height: 50, fontWeight: 600 }} onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  )
}
